<template>
  <div class="toolbox-menu-item" :class="{ 'toolbox-menu-item__slim': slimMobile }">
    <div class="toolbox-menu-item__heading">
      <h4 v-if="title?.length" class="toolbox-menu-item__title">
        {{ title }}
      </h4>
      <img
        v-if="iconSource && !subTitle?.length"
        class="toolbox-menu-item__icon"
        :src="iconSource"
        @click="$emit('onIconClick')"
        alt="title icon"
      />
    </div>
    <div v-if="subTitle?.length" class="toolbox-menu-item__heading__subtitle">
      <h4 class="toolbox-menu-item__subtitle">
        {{ subTitle }}
      </h4>
      <img
        v-if="iconSource"
        class="toolbox-menu-item__icon"
        :src="iconSource"
        @click="$emit('onIconClick')"
        alt="subtitle icon"
      />
    </div>
    <slot />
  </div>
</template>

/** A component for every entity in the toolbox menu **/
<script>
export default {
  name: 'ToolboxMenuItem',
  props: {
    iconSource: {
      type: String,
      default: ''
    },
    slimMobile: {
      type: Boolean,
      default: false
    },
    subTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  emits: ['onIconClick']
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';

.toolbox-menu-item {
  background-color: variables.$color-grey-blue-dark;
  padding: 0 variables.$margin-small;
  border-radius: variables.$border-radius-medium;
  &:last-child {
    margin-bottom: 0;
  }
  &__heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__subtitle {
      display: flex;
      justify-content: space-between;
    }
  }
  &__icon {
    filter: brightness(0) saturate(100%) invert(88%) sepia(0%) saturate(1%) hue-rotate(165deg)
      brightness(93%) contrast(95%);
    height: 16px;
    width: 16px;
  }
  &__title {
    color: variables.$color-text-white-70;
    font-weight: variables.$font-weight-general-paragraph;
    padding-right: 5px;
  }
  &__subtitle {
    color: variables.$color-text-white-70;
    font-weight: variables.$font-weight-general-paragraph;
    margin-top: 0;
    padding-right: 5px;
  }
  p {
    color: variables.$color-text-white-70;
    margin: 0;
  }
}

@media screen and (max-width: 1024px) {
  .toolbox-menu-item {
    top: 65px;
    right: variables.$margin-small;
  }
}
@media screen and (max-width: 658px) {
  .toolbox-menu-item {
    width: unset;
    &__title {
      white-space: nowrap;
    }
    &__slim {
      display: flex;
      flex-direction: column;
      background-color: variables.$color-grey-blue-dark;
      padding: 0px 13px 0px 13px;
      border-radius: variables.$border-radius-medium;
      overflow: hidden;
    }
  }
}
</style>
